// extracted by mini-css-extract-plugin
export var arrow = "button-module--arrow--0ee25";
export var border = "button-module--border--362f4";
export var borderG = "button-module--borderG--c9b0e";
export var btnArrow = "button-module--btnArrow--60e0f";
export var button = "button-module--button--1cccc";
export var dark = "button-module--dark--45601";
export var darken = "button-module--darken--44415";
export var gradient = "button-module--gradient--e9424";
export var gray = "button-module--gray--8ae2a";
export var green = "button-module--green--d922c";
export var light = "button-module--light--fdf55";
export var lightB = "button-module--lightB--7bb5b";
export var lightG = "button-module--lightG--58d05";
export var lineThrough = "button-module--lineThrough--5a7d6";
export var none = "button-module--none--c6f56";
export var noneB = "button-module--noneB--e7062";
export var noneD = "button-module--noneD--2f28f";
export var text = "button-module--text--58f7b";